/**
 * Font-size ladder for rich text inside `MathEditor`, and the pure rule that
 * picks the next rung for the "Increase / Decrease Font Size" actions.
 *
 * Extracted from `MathEditor.tsx` so the stepping rule can be unit-tested: the
 * measurement half (reading `getComputedStyle().fontSize` off the DOM) needs a
 * real browser, but the decision half is arithmetic over two numbers and does
 * not.
 */
/** Font size steps for text, in pixels, ascending. */
export var FONT_SIZE_STEPS = [12, 14, 16, 18, 20, 24, 28, 32, 36, 42, 48, 56, 64, 72];
/**
 * The size (px) a selection should become when the user asks for the next step
 * in `direction`.
 *
 * A mixed selection unifies to a single size, and the button's direction must
 * hold for EVERY run in it — so grow from the largest size present and shrink
 * from the smallest. Growing from anything but `max` is what made "Larger"
 * visibly shrink a selection that covered a 48px span plus plain text (it read
 * the box's 20px base and stepped to 24px); shrinking from anything but `min`
 * is the same bug mirrored (12px + 96px stepping "one below the largest" to
 * 72px enlarges the 12px run).
 *
 * Comparisons are strict, so a size sitting between two rungs still moves.
 * Past the top of the ladder there is no next rung, so `larger` grows by 10%
 * (at least 1px, so it always moves); below the bottom rung `smaller` clamps.
 */
export var nextFontSizeStep = function (direction, _a) {
    var min = _a.min, max = _a.max;
    if (direction === 'larger') {
        var nextStep = FONT_SIZE_STEPS.find(function (s) { return s > max; });
        return nextStep !== null && nextStep !== void 0 ? nextStep : Math.max(max + 1, Math.round(max * 1.1));
    }
    var lowerSteps = FONT_SIZE_STEPS.filter(function (s) { return s < min; });
    return lowerSteps.length > 0 ? lowerSteps[lowerSteps.length - 1] : FONT_SIZE_STEPS[0];
};
